import Paths from "common/paths/paths";
import { CatalogCategory, CatalogItem } from "interfaces";
import { useNavigate } from "react-router-dom";

/**
 * Props for the useNewOrderNavigate hook
 *
 * @interface
 * @property {Map<CatalogRequestResponse, number> | null} itemsSelected - The items selected for the new order mapped to their corresponding quantity
 * @property {boolean} isOrderStandard - True if the order is standard and False if the order is non standard
 */
export interface NavigateNewOrderProps {
    itemsSelected: Map<CatalogItem, number> | null;
    isOrderStandard: boolean;
}

/**
 * The received data in the the order confirmation page
 *
 * @property {CatalogCategory[]} categories - The retrieve categories from itsehamaux
 */
export interface NavigateNewOrderResponse extends NavigateNewOrderProps {
    categories: CatalogCategory[];
}

/**
 * The order navigation path
 */
const orderNavigationPath: string = Paths.itOrderConfirmation.url;

/**
 * Custom hook to navigate to new order page sending the corresponding parameters
 * @param {CatalogCategory[]} categories - the categories retrieved from itsehamaux
 *
 * @returns {useNewOrderNavigateOutput} - An object containing the function to navigate to the new order page
 */
export function useNewOrderNavigate({ categories }: { categories: CatalogCategory[] }) {
    const navigate = useNavigate();

    const navigateToNewOrder = ({ itemsSelected, isOrderStandard }: NavigateNewOrderProps) => {
        navigate(orderNavigationPath, {
            state: {
                itemsSelected,
                isOrderStandard,
                categories,
            },
        });
    };

    return { navigateToNewOrder };
}
